if (document.querySelector('.purchase_flow_main')) {
  
  // Function to be called every 2 seconds
  // function repeatFunction() {
  //   if (document.querySelector(".purchase_flow_main_container .purchase_flow_question:not(.hidden)")) {
  //     let overall_height = window.innerHeight;
  //     let content_height = document.querySelector(".purchase_flow_main_container .purchase_flow_question:not(.hidden)").offsetHeight + 140;
  //     if(content_height > overall_height){
  //         document.querySelector(".purchase_flow_main_container").classList.add("over_size_container");
  //         document.querySelector(".purchase_flow_main").classList.add("over_size_maincontainer");
  //     }else{
  //        document.querySelector(".purchase_flow_main_container").classList.remove("over_size_container");
  //        document.querySelector(".purchase_flow_main").classList.remove("over_size_maincontainer");
  //     }
  //   }
  // }
  
  // setInterval(repeatFunction, 100);

  function closeAllDiv() {
    const all_hidden = document.querySelectorAll('.purchase_flow_question');
    all_hidden.forEach(data=>{
      data.classList.add('hidden');
    });
  }
  // logo and close button click
  const Logo_clicks = document.querySelectorAll('.close_setp_popup');
  Logo_clicks.forEach(item=>{
    item.addEventListener("click",()=>{
      if (document.querySelector('.purchase_flow_question.custom_form_div.hidden.open_div')) {
        document.querySelector('.purchase_flow_question.custom_form_div.hidden.open_div').classList.remove('open_div');
      }
      document.querySelector('.purchase_flow_question.custom_form_div:not(.hidden)').classList.add('open_div');
      // document.querySelector('.purchase_flow_question.custom_form_div:not(.hidden)').closest('.purchase_flow_main_container').querySelector('.custom_form_div').classList.add('open_div');
      closeAllDiv();
      document.querySelector('.flow_close_screen_content').classList.add('open_poup');
      document.querySelector('.flow_close_screen_content').classList.remove('hidden');
    });
  });
  
  
  // yes continue button click
  var Continue = document.querySelectorAll('.back_step_1');
  Continue.forEach(dat=>{
    dat.addEventListener("click",()=>{
      document.querySelector('.purchase_flow_question.custom_form_div.open_div').classList.remove('hidden');
      document.querySelector('.flow_close_screen_content').classList.remove('open_poup');
      document.querySelector('.flow_close_screen_content').classList.add('hidden');
    });
  });

  // back button
  const bacK_btns = document.querySelectorAll('.back-button');
  bacK_btns.forEach(item=>{
    item.addEventListener("click",()=>{
      const pre_div = item.getAttribute('pre_div');
      closeAllDiv();
     document.querySelector('.purchase_flow_question[show_div="'+ pre_div +'"]').classList.remove('hidden');
    });
  });
  
  // Start the steps show
  
  // Setp 1
  document.querySelector('.start_button').addEventListener("click",()=>{
    closeAllDiv();
    document.querySelector('.flow_question_2').classList.remove('hidden');
  });
  
  // input button disable
  document.querySelector('.flow_name_text').addEventListener("keyup", ()=>{
     document.querySelector('.add_text_name').classList.remove('disable');
    if (document.querySelector('.flow_name_text').value == '') {
      document.querySelector('.add_text_name').classList.add('disable');
    }
  });
  
  // name set on button click
  
  document.querySelector('.add_text_name').addEventListener("click", ()=>{
    const input_vale = document.querySelector('.flow_name_text').value;
    const add_name = document.querySelectorAll('name-text');
    add_name.forEach(item =>{
      item.innerHTML = input_vale;
    });  
     closeAllDiv();
     document.querySelector('.flow_question_3').classList.remove('hidden');
     const show_time = document.querySelector('[show_time]').getAttribute('show_time');
     setTimeout(() => {
       closeAllDiv();
       document.querySelector('.flow_question_4').classList.remove('hidden');
     }, show_time);
  });
  
  // select button
  const gender_btn = document.querySelectorAll('.gender_btn');
  gender_btn.forEach(item =>{
    item.addEventListener("click",()=>{
      if (document.querySelector('.gender_btn.selected')) {
       document.querySelector('.gender_btn.selected').classList.remove('selected'); 
      }      
      item.classList.toggle('selected');
      if (item.getAttribute('gender_name') == 'male' || item.getAttribute('gender_name') == 'hombre' ) {
       closeAllDiv();
       document.querySelector('.flow_question_7').classList.remove('hidden');
      }else{
        closeAllDiv();
        document.querySelector('.flow_question_5').classList.remove('hidden');
      }
      // vlaue set
      var gender_name = document.querySelector('.gender_btn.selected').getAttribute('text_get');
    });
  });  
  
  const pre_btn = document.querySelectorAll('.pre_btn');
  pre_btn.forEach(item =>{
    item.addEventListener("click",()=>{
      if (document.querySelector('.pre_btn.selected')) {
        document.querySelector('.pre_btn.selected').classList.remove('selected');
      }      
      item.classList.toggle('selected');
      if (item.getAttribute('pre_btn') == 'no' ) {
         closeAllDiv();
        document.querySelector('.flow_question_7').classList.remove('hidden');
      }else{
        closeAllDiv();
        document.querySelector('.flow_question_6').classList.remove('hidden');
      }
    });
  });
  
  document.querySelector('.conform_btn').addEventListener("click",()=>{
    closeAllDiv();
    document.querySelector('.flow_question_7').classList.remove('hidden');
  });
  
  // age 
  document.querySelector('.age_text').addEventListener("keyup", ()=>{
     document.querySelector('.age_btn').classList.remove('disable');
    if (document.querySelector('.age_text').value == '') {
      document.querySelector('.age_btn').classList.add('disable');
    }
  });
  
  document.querySelector('.age_btn').addEventListener("click",()=>{
    const age_number = document.querySelector('.age_text').value;
    if (age_number < 18) {
      closeAllDiv();
      document.querySelector('.flow_question_8').classList.remove('hidden');
    }else{
      closeAllDiv();
      document.querySelector('.flow_question_9').classList.remove('hidden');
    }
  });

  document.querySelector('.conform_btn_2').addEventListener("click",()=>{
    closeAllDiv();
    document.querySelector('.flow_question_9').classList.remove('hidden');
  });
  
  const sel_btn = document.querySelectorAll('.selected_option_btn');
  sel_btn.forEach(item =>{
    item.addEventListener("click",()=>{
      item.classList.toggle('button--grey-active');
    });
  });
  
  // document.querySelector('.input_sport').addEventListener("click", ()=>{
  //   document.querySelector('.input_sport').classList.add('button--grey-active');
  // });
  
  // document.querySelector('.input_sport').addEventListener("keyup", ()=>{
  //   document.querySelector('.input_sport').classList.add('button--grey-active');
  //   if (document.querySelector('.input_sport').value == '') {
  //     document.querySelector('.input_sport').classList.remove('button--grey-active');
  //   }
  // });
  
  document.querySelector('.conform_selected_btn').addEventListener("click",()=>{
    closeAllDiv();
    document.querySelector('.flow_question_10').classList.remove('hidden');
    // add value
    //   const symptoms = [];
    //   var s_names = document.querySelectorAll('.selected_option_btn.button--grey-active span');
    //   s_names.forEach(s_name =>{
    //     symptoms.push(s_name.innerHTML);
    //   });
    //   var s_inputname = document.querySelector('input.input_sport').value;
    //   if (s_inputname != '') {
    //    symptoms.push(s_inputname);
    //   }
    // var symptoms_ = symptoms.join(', ');
    // console.log(symptoms_)
  });
  
  
  document.querySelector('.time_con_btn').addEventListener("click",()=>{
    closeAllDiv();
    document.querySelector('.flow_question_11').classList.remove('hidden');
  });

  const input_fileds = document.querySelectorAll('.input_filed_last');
  input_fileds.forEach(item =>{
    item.addEventListener("keyup", ()=>{
      document.querySelector('.submit_last_btn').classList.remove('disable');
      if (item.value == '') {
        document.querySelector('.submit_last_btn').classList.add('disable');
      }
  });
});


  // input_filed_last current_country_code
  document.getElementById('country_code').addEventListener('change', function(event) {
    const selectedValue = this.value;
    document.querySelector('.current_country_code').innerHTML = selectedValue;
  });
  
  
   document.getElementById('subscription_from').addEventListener('submit', function(event) {
    // Prevent form submission
      event.preventDefault();

      // Get input values
      const email = document.querySelector('[name="email"][custom-klaviyo]').value;
      var pCode = document.querySelector('.current_country_code').innerHTML;
      var pNumber = document.querySelector('input[name="phone"]').value;
     
      const phone = pCode + pNumber;

     console.log(phone)

      // Get error elements
      const emailError = document.querySelector('.emailError');
      const phoneError = document.querySelector('.phoneError');

      // Clear previous errors
      emailError.classList.add('hidden');
      phoneError.classList.add('hidden');

      // Validate email
      let isValid = true;
       console.log("2",email)
     console.log("3",!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(email))
      if (!email || !/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(email)) {
          emailError.classList.remove('hidden');
          isValid = false;
      }

     console.log("d",isValid)


      const symptoms = [];
      var s_names = document.querySelectorAll('.selected_option_btn.button--grey-active span');
      s_names.forEach(s_name =>{
        symptoms.push(s_name.innerHTML);
      });
      var s_inputname = document.querySelector('input.input_sport').value;
      if (s_inputname != '') {
       symptoms.push(s_inputname);
      }
    var symptoms_ = symptoms.join(', ');
      

     var sport = null ;
     if (document.querySelector('input[name="time"]:checked')) {
       sport = document.querySelector('input[name="time"]:checked').value;
     }
     
    if (isValid) {

     document.querySelector('.submit_last_btn').classList.add('loder');

     var pCode = document.querySelector('.current_country_code').innerHTML;
     var pNumber = document.querySelector('input[name="phone"]').value;
     const lang = document.querySelector('html').getAttribute('lang');

     // const data_add = {
     //     "email": email,
     //     "phone_number": phone,
     //     "first_name": document.querySelector('.flow_name_text').value,
     //     "properties": {
     //         "gender": document.querySelector('.gender_btn.selected').getAttribute('text_get'),
     //         "age": document.querySelector('.age_text').value,
     //         "symptoms": symptoms_,
     //         "sport": sport
     //     }
     // }

      var pregnant_data ;
      if(document.querySelector('.pre_btn.selected')){
        pregnant_data = document.querySelector('.pre_btn.selected').getAttribute('btn_name');
      }else{
        pregnant_data = null ;
      }
       
      var myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");
          
          const raw = JSON.stringify({
            "data": {
              "type": "profile",
              "attributes": {
                 "email": email,
                "phone_number": phone,
                 "first_name": document.querySelector('.flow_name_text').value,
                "properties": {
                  "gender": document.querySelector('.gender_btn.selected').getAttribute('text_get'),
                  "age": document.querySelector('.age_text').value,
                  "symptoms": symptoms_ || null,
                   "sport": sport || null,
                  "pregnant" : pregnant_data
                }
              }
            }
          });
          
          var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
          };
          
          fetch("https://app.pletoscience.com/app/klaviyo_final.php", requestOptions)
            .then(response => response.json())
            .then((result) => {
               var res = result;
               console.log(res)
               if (res) {
                   if (res.errors) {
                       document.querySelector('.submit_last_btn').classList.remove('loder');
                       var errtext = res.errors[0].detail;
                       if (errtext == 'A profile already exists with one of these identifiers.') {
                           if (lang == 'en') {
                               window.location.href = '/en/products/pleto-subscription';
                           } else {
                               window.location.href = '/products/pleto-subscription';
                           }
                       } else {
                           if (lang == 'en') {
                               errtext = 'Invalid phone number format (Example of a valid format: 675886543 or 788976323)';
                           } else if (lang == 'es') {
                               errtext = 'Formato de número de teléfono no válido (Ejemplo de un formato válido: 675886543 o 788976323)';
                           }
                           document.querySelector('.form_error').innerHTML = errtext;
                           console.log(errtext);
                       }
                   } else {
                       if (lang == 'en') {
                           window.location.href = '/en/products/pleto-subscription';
                       } else {
                           window.location.href = '/products/pleto-subscription';
                       }
                   }
  
               }
           })
          .catch(error => console.log('error', error));
       } // is data is valid
  });

}



function locstock_popup() {
  const divSelector = document.querySelector('[lowStockpopup]');
  if (divSelector) {
    const showHome = divSelector.getAttribute('show_homePage');
    const showProduct = divSelector.getAttribute('show_productPage');
    const showafter = divSelector.getAttribute('popup_time');
      if (document.body.classList.contains('template-index')) {
    if (showHome) {
      console.log("showHome",showHome)
        console.log("3333")
        setTimeout(() => {
          divSelector.classList.remove('hidden');
        },showafter);
      }else{
          console.log("55")
        }
    } 
      if (document.body.classList.contains('template-product')) {
    if (showProduct) {
        console.log("showProduct in",showProduct)
        setTimeout(() => {
          divSelector.classList.remove('hidden');
        },showafter);
      } else {
        console.log("222")
      }
    }
    console.log("showProduct",showProduct, document.body.classList.contains('template-product'))
  }
}

window.addEventListener('load', (event) => {
  /*-- Review Page --*/
  if(location.hash.indexOf("revisiones") > -1) {
    var reviewLink = document.querySelector('.jdgm-write-rev-link');
    reviewLink.click();
  }
  
  // locstock_popup();  
});

// page scroll show hide timebar
// if (document.body.classList.contains("Show_timer_on_scroll")) {
//   let lastScrollTop = window.scrollY;
//   const elements = document.querySelectorAll(".custom-timer-bar");
//   let isHidden = false;

//   window.addEventListener('scroll', function() {
//     let st = window.scrollY;

//     if (st > lastScrollTop && !isHidden) {
//       // Scrolling down
//       elements.forEach(el => el.classList.add("hidden"));
//       document.body.classList.add("time_bar_hide");
//       isHidden = true;
//     } 
//     else if (st < lastScrollTop && isHidden) {
//       // Scrolling up
//       elements.forEach(el => el.classList.remove("hidden"));
//       document.body.classList.remove("time_bar_hide");
//       isHidden = false;
//     }

//     lastScrollTop = st <= 0 ? 0 : st; // Ensure no negative values
//   });
// }



if (document.body.classList.contains("Show_timer_on_scroll")) {
  let lastScrollTop = window.scrollY;
  const element = document.querySelector(".custom-timer-bar");

  window.addEventListener('scroll', function() {
    let currentScroll = window.scrollY;

    if (currentScroll > lastScrollTop && currentScroll > 50) {
      if (!element.classList.contains("hidden_timer")) {
        element.classList.add("hidden_timer");
      }
    } else if (currentScroll < lastScrollTop) {
      if (element.classList.contains("hidden_timer")) {
        element.classList.remove("hidden_timer"); 
      }
    }

    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  });
}



// if (document.body.classList.contains("Show_timer_on_scroll")) {
//   let lastScrollTop = window.scrollY;
//   const element = document.querySelector(".custom-timer-bar");

//   window.addEventListener('scroll', function() {
//     let currentScroll = window.scrollY;

//     if (currentScroll > lastScrollTop && currentScroll > 50) {
//       // Scrolling down
//       if (!element.classList.contains("hidden")) {
//         element.classList.add("hidden");
//         // document.body.classList.add("time_bar_hide");
//       }
//     } else if (currentScroll < lastScrollTop) {
//       // Scrolling up
//       if (element.classList.contains("hidden")) {
//         element.classList.remove("hidden");
//         // document.body.classList.remove("time_bar_hide"); 
//       }
//     }

//     lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
//   });
// }

if(document.body.classList.contains("Free_scroll")) {
  window.addEventListener("scroll", function () {
    if (window.scrollY > 50) {
      document.body.classList.add("free_scroll_show");
    } else {
      document.body.classList.remove("free_scroll_show");
    }
});
}


    document.querySelectorAll('[header_button]').forEach(function (button) {
        console.log(111);
        button.addEventListener("click",()=>{
            document.querySelector('.addtocartclass').click();
        });
    });

//end page scroll show hide timebar


// let custom_pageflow_height = window.innerHeight;
// const layoutElement = document.querySelector(".template-page.pleto-purchase-flow .content-for-layout");
// const wrapperElement = document.querySelector(".main-flow-content-wrapper");

// if (layoutElement) {
//     layoutElement.style.minHeight = custom_pageflow_height + "px";
// }
// if (wrapperElement) {
//     wrapperElement.style.minHeight = custom_pageflow_height + "px";
// }


// const purchaseElement = document.querySelector(".purchase_flow_main_container");
// if (purchaseElement && window.innerWidth < 750) {
//   const purchase_flow_header = document.querySelector(".purchase_flow_header");
//   const timer_bar_section = document.querySelector(".timer-bar-section");
//   const windowHeight = window.innerHeight;

//   if (purchase_flow_header && timer_bar_section) {
//     const headerHeight = purchase_flow_header.offsetHeight || 0;
//     const timerHeight = timer_bar_section.offsetHeight || 0;
//     // const winHeight = windowHeight.offsetHeight || 0;
    
//     console.log("winHeight:",windowHeight);
    
//     const newHeight = windowHeight  - timerHeight;
//     console.log("Calculated Height:", newHeight);
//     purchaseElement.style.minHeight = newHeight + "px";
//     purchaseElement.style.maxHeight = newHeight + "px";
//   }
// }